package ui.widget

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.layout.ContentScale
import io.Repository
import kotlinx.coroutines.isActive
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState


@Composable
fun LazyIcon(
    id: Long, modifier: Modifier,
    contentScale: ContentScale = ContentScale.Fit,
    alphaBackground: Boolean = false,
    tint:Color = MaterialTheme.colorScheme.onSurface) {
    val imageState = remember(id) {
        mutableDataState<Painter>()
    }
    Box(modifier) {
        when (val state = imageState.value) {
            is DataState.Idle -> Unit
            is DataState.Error -> Text("Fetch ERR", Modifier.align(Alignment.Center))
            is DataState.Loading -> {
                CircularProgressIndicator(Modifier.align(Alignment.Center))
            }

            is DataState.Result -> {
                Image(
                    painter = state.nnvl,
                    alignment = Alignment.Center,
                    contentDescription = null,
                    contentScale = contentScale,
                    colorFilter = ColorFilter.tint(tint),
                    modifier = Modifier.fillMaxSize()
                        .then(
                            if (alphaBackground) Modifier.drawAlphaBackground()
                            else Modifier
                        )
                )
            }
        }
    }
    LaunchedEffect(id) {
        if (Repository.files.containsIcon(id)) {
            imageState.value = DataState.Result(Repository.files.fetchIcon(id))
        } else {
            imageState.value = DataState.Loading()
            runCatching {
                Repository.files.fetchIcon(id)
            }.onSuccess {
                if (isActive) imageState.value = DataState.Result(it)
            }.onFailure {
                if (isActive) imageState.value = DataState.Error(it.message ?: "Fetch fail")
            }
        }
    }
}
